import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClosePropService {
  openOtherProp: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }
}
